import React, { useState } from "react";
import ModalShell, { ModalHeader, MODAL_Z } from "./ModalShell";
import StatusBadge from "./StatusBadge";
import { COMPARE_FIELDS } from "./constants";
import { formatTs, formatValue } from "./format";
import { getFieldAlias, getFieldValue } from "./compare";

// one table row of one stage, as Field | Value
//   showAll=false -> only the COMPARE_FIELDS, showAll=true -> every column
//   the user can flip it with the switch inside the popup
export default function DataModal({ record, stage, showAll = false, onClose }) {
  const [all, setAll] = useState(showAll);

  const entries = all
    ? Object.entries(stage.data || {})
    : COMPARE_FIELDS.map((key) => [key, getFieldValue(stage, key)]).filter(
        ([, value]) => value !== undefined
      );

  return (
    // z above the Compare modal, which can open this one
    <ModalShell onClose={onClose} size="modal-lg" z={MODAL_Z + 20}>
      <ModalHeader
        title={`${stage.stageLabel} - ${String(record.id)}`}
        subtitle={`${stage.stageSearch} | ${record.name} | ${formatTs(stage.timestamp)}`}
        onClose={onClose}
      />

      <div className="modal-body">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <StatusBadge found={stage.found} />
          <div className="form-check form-switch mb-0">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="allFields"
              checked={all}
              onChange={(e) => setAll(e.target.checked)}
            />
            <label className="form-check-label small" htmlFor="allFields">
              All fields ({Object.keys(stage.data || {}).length})
            </label>
          </div>
        </div>

        <table className="table table-sm table-striped align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th style={{ width: "30%" }}>Field</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {entries.map(([key, value]) => {
              const alias = all ? null : getFieldAlias(stage, key);
              return (
                <tr key={key}>
                  <td className="fw-semibold">
                    {key}
                    {alias && (
                      <span className="fw-normal text-secondary ms-1">({alias})</span>
                    )}
                  </td>
                  <td className="text-break">{formatValue(value)}</td>
                </tr>
              );
            })}
            {entries.length === 0 && (
              <tr>
                <td colSpan={2} className="text-center text-secondary py-3">
                  None of the configured fields exist in this table.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Close
        </button>
      </div>
    </ModalShell>
  );
}
